import { ITitle } from 'services/types';

export const getMainTitle = (mainTitle?: ITitle) =>
  mainTitle
    ? `${mainTitle.title} ${
        mainTitle.version ? `  -  ${mainTitle.version}` : ''
      } `
    : '-';
